import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { FacadeService } from '@app/services/facade.service';
import { CountryService } from '../../../services/shared/country.service';
import { Country } from '../../models/components/country';
import { Option } from '../../models/components/Address';

const KUWAIT_CODE: string = '965';
@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.scss']
})
export class CountriesComponent implements OnInit {

  public readonly imageUrl = 'assets/images/flags/';

  @Output() country: EventEmitter<Country> = new EventEmitter<Country>();
  @Output() governorates: EventEmitter<Option[]> = new EventEmitter<Option[]>();
  @Input() isRemoveLocalCountry: boolean = false;

  @Input() previousCountryId: number;
  @Input() countryRequired:boolean=false;
  @Input() states: Country[] = [];

  selectedState: Country;
  msgError: string = '';

  /**
   *
   * @param countryService
   */
  constructor(private countryService: CountryService, private facadeService: FacadeService) {
  }

  ngOnInit() {
    if (!this.states || this.states.length <= 0) {
      this.countriesCodes();
    }

    // if(this.states && this.previousCountryId > 0){
    //   this.selectedState = this.states.find(c => c.id == this.previousCountryId)
    // }
  }

  /**
   * 
   * @param simpleChanges 
   */
  ngOnChanges(simpleChanges: SimpleChanges) {    
    if (simpleChanges && simpleChanges.previousCountryId) {
      this.previousCountryId = simpleChanges.previousCountryId.currentValue;
      this.setSelectedPrevious(this.states, this.previousCountryId);
    }

    if (simpleChanges && simpleChanges.isRemoveLocalCountry) {
      this.isRemoveLocalCountry = simpleChanges.isRemoveLocalCountry.currentValue;
    }

    if (simpleChanges && simpleChanges.states) {
      this.states = simpleChanges.states.currentValue;
    }
  }

  /**
   * list countries codes
   *
   *
   */
  countriesCodes() {    
    this.countryService.list().subscribe((countries: Country[]) => {
      if (this.isRemoveLocalCountry) {
        countries = countries.filter(country => country.code != KUWAIT_CODE);
      }
      this.states = countries;

      // push old value
      if (this.previousCountryId) {
        this.setSelectedPrevious(this.states, this.previousCountryId);
      } else {
        const selectedCountry = this.states.filter(state => {
          return state.code == KUWAIT_CODE;
        })[0];

        this.country.emit(selectedCountry);

        // set kuwait default country
        if (selectedCountry && selectedCountry.id) {
          this.setSelectedPrevious(this.states, selectedCountry.id);
          this.setValue();
        }
      }
    });
  }

  /**
   * emit country value
   *
   *
   * @param event
   */
  setValue() {
    this.country.emit(this.selectedState);
  }

  /**
   * set selected previous country
   *
   *
   * @param countries
   * @param id
   */
  setSelectedPrevious(countries: Country[], id: number): void {
    countries.forEach(country => {
      if (country.id == id) {
        this.selectedState = country;
        this.country.emit(this.selectedState);
        this.governoratesByCountryId(String(this.selectedState.id));
        return;
      }
    })
  }

  /**
   * set selected previous country
   * 
   * 
   * @param countries 
   * @param code 
   */
  setSelectedPreviousAccordingToCode(countries: Country[], code: string) {
    countries.forEach(country => {
      if (country.topLevel == code.toLocaleLowerCase()) {
        this.selectedState = country;
        this.country.emit(this.selectedState);
      }
    })
  }

  governoratesByCountryId(id: string): void {
    this.facadeService.addressService.governoratesByCountryId(id).subscribe(res => {
      this.governorates.emit(res);
    });
  }

  selectionChange(event: MatSelectChange): void {
    this.governoratesByCountryId(event.value.id);
  }
}
